import React, {Component} from "react";
import InternalSpecialityEnum from "../../../treatment/enums/referral/InternalSpecialityEnum";
import InterventionTypeEnum from "../../../treatment/enums/referral/InterventionTypeEnum";
import DateUtil from "../../../../../../utils/DateUtil";

export default class ReferralHistory extends Component {

    render() {
        return (
            <>
                {
                    this.props.referral != null && this.props.referral.internals.length > 0 &&
                    <div className="pt-3">
                        <div>
                            <h5 className="font-weight-bold">Internal</h5>
                            <table className={"visit-history-table"}>
                                <tbody>
                                <tr style={{backgroundColor: "rgba(197, 224, 181, 0.4)"}}>
                                    <th>Speciality</th>
                                    <th>Provider Name</th>
                                    <th>CPT Code</th>
                                    <th>No of Sessions</th>
                                    <th>Reason</th>
                                    <th>Priority</th>
                                    <th>Effective Date</th>
                                </tr>
                                {
                                    this.props.referral.internals.map((item, index) => {
                                            return (
                                                <tr key={index} style={{backgroundColor: "white"}}>
                                                    <td>{InternalSpecialityEnum[item.speciality]?.name}</td>
                                                    <td>{item.provider?.name}</td>
                                                    <td>{item.cptCodeList.map(cpt => cpt.cptCode).join(", ")}</td>
                                                    <td>{item.noOfSessions}</td>
                                                    <td>{item.referralReason?.name}</td>
                                                    <td>{item.referralPriority?.name}</td>
                                                    <td>{DateUtil.formatDateMMM(item.effectiveDate)}</td>
                                                </tr>);
                                        }
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
                {
                    this.props.referral != null && this.props.referral.externals.length > 0 &&
                    <div className="pt-3">
                        <div>
                            <h5 className="font-weight-bold">External</h5>
                            <table className={"visit-history-table"}>
                                <tbody>
                                <tr style={{backgroundColor: "rgba(197, 224, 181, 0.4)"}}>
                                    <th>Speciality</th>
                                    <th>Reason</th>
                                    <th>Priority</th>
                                    <th>Facility Name</th>
                                    <th>Effective Date</th>
                                    <th>Recommendations</th>
                                </tr>
                                {
                                    this.props.referral.externals.map((item, index) => {
                                            return (
                                                <tr key={index} style={{backgroundColor: "white"}}>
                                                    <td>{item.speciality?.name}</td>
                                                    <td>{item.referralReason?.name}</td>
                                                    <td>{item.referralPriority?.name}</td>
                                                    <td>{item.referralFacility?.name}</td>
                                                    <td>{DateUtil.formatDateMMM(item.effectiveDate)}</td>
                                                    <td>{item.recommendations}</td>
                                                </tr>);
                                        }
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
                {
                    this.props.referral != null && this.props.referral.interventions.length > 0 &&
                    <div className="pt-3">
                        <div>
                            <h5 className="font-weight-bold">Interventions</h5>
                            <table className={"visit-history-table"}>
                                <tbody>
                                <tr style={{backgroundColor: "rgba(197, 224, 181, 0.4)"}}>
                                    <th>Type</th>
                                    <th>Details</th>
                                    <th>Recommendations</th>
                                    <th>Remarks</th>
                                </tr>
                                {
                                    this.props.referral.interventions.map((item, index) => {
                                            return (
                                                <tr key={index} style={{backgroundColor: "white"}}>
                                                    <td>{InterventionTypeEnum[item.type]?.name}</td>
                                                    <td>{item.details}</td>
                                                    <td>{item.recommendations}</td>
                                                    <td>{item.remarks}</td>
                                                </tr>);
                                        }
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
            </>
        )
    }

}
